import React from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { rows } from "./data";

const statuses = [...new Set(rows.map((row) => row.status))];

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Employee Name
        </InputLabel>
        <TextField
          variant="outlined"
          name="employeeName"
          value={filterData.employeeName}
          onChange={handleChangeFilter("employeeName")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Device Number
        </InputLabel>
        <TextField
          variant="outlined"
          name="deviceNumber"
          value={filterData.deviceNumber}
          onChange={handleChangeFilter("deviceNumber")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Status
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.status}
            onChange={(e) => handleChangeFilter("status")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="">All</MenuItem>
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Orders (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="totalOrdersMin"
          type="number"
          value={filterData.totalOrdersMin}
          onChange={handleChangeFilter("totalOrdersMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Orders (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="totalOrdersMax"
          type="number"
          value={filterData.totalOrdersMax}
          onChange={handleChangeFilter("totalOrdersMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Priority Orders Min
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.priorityOrdersMin}
          onChange={handleChangeFilter("priorityOrdersMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Priority Orders Max
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.priorityOrdersMax}
          onChange={handleChangeFilter("priorityOrdersMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Order Lines (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLinesMin"
          type="number"
          value={filterData.orderLinesMin}
          onChange={handleChangeFilter("orderLinesMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Order Lines (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLinesMax"
          type="number"
          value={filterData.orderLinesMax}
          onChange={handleChangeFilter("orderLinesMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Items (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="totalItemsMin"
          type="number"
          value={filterData.totalItemsMin}
          onChange={handleChangeFilter("totalItemsMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Items (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="totalItemsMax"
          type="number"
          value={filterData.totalItemsMax}
          onChange={handleChangeFilter("totalItemsMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1 }}
          >
            Clear
          </Button>
          <Button variant="contained" color="primary" onClick={handleFilter}>
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
